import { SEARCH_PHRASE_MIN_LENGTH } from 'constants/globalSearch/SEARCH_PHRASE_MIN_LENGTH';

export const validateSearchPhrase = (searchPhrase: string) => searchPhrase.length >= SEARCH_PHRASE_MIN_LENGTH;
